import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import settings from '../../libs/config';
import Logger from '../../functions/logging';

import { getUser } from '../../api/user';
import * as authFns from '../../functions/auth';
import * as TargetProcess from '../../functions/targetProcess';
import * as actions from '../../redux/actions';
import BluePilotlyLogo from '../../assets/landing/BluePilotlyLogo';
import WhitePilotlyLogo from '../../assets/landing/WhitePilotlyLogo';
import LocaleButton from '../global/LocaleButton';

/* Google analytics */
import SessionStatus from '../../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../../analytics/analytics-events/constants';
import { isTesterFromUrl } from '../../functions/helpers';

/**
 * This utility function allows function calls to be debounced.
 * @param {Function} func Function that requires debouncing
 * @param {Number} wait Wait time in milliseconds between successive invocations
 */

const debounce = (func, wait) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
};

class LandingHeader extends Component {
	constructor(props) {
		super(props);
		this.disableScroll = false || props.disableScroll;
		this.state = {
			errors: {},
			scrollPositionY: 0,
			isThirdPartyUser: false
		};
	}

	componentDidMount() {
		// 32 is the number of milliseconds to debounce
		// I picked this because it's approx 2 frames (ie: 16.7 * 2)
		let user_token = authFns.getToken();
		if (user_token && !this.props.currentUser) this.loadUser(user_token);

		// we're no longer auto routing the user to the third party url, 
		// then we should auto logout if they are routed back to the parent
		authFns.checkThirdPartyEndDate();
		let thirdPartyUrl = authFns.getThirdPartyUrl();
		if (thirdPartyUrl) authFns.logout();

		// return window.addEventListener('scroll', debounce(this.handleScroll, 32));
		return document.body.addEventListener('scroll', debounce(this.handleScroll, 32));
	}

	componentWillUnmount() {
		// return window.removeEventListener('scroll', debounce(this.handleScroll, 32));
		return document.body.removeEventListener('scroll', debounce(this.handleScroll, 32));
	}

	async loadUser(user_token) {
		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() result", result);
				this.props.setCurrentUser(result);
				let isThirdPartyUser = TargetProcess.isThirdPartyUser(result);
				this.setState({ isThirdPartyUser: isThirdPartyUser, currentUser: result });
			}
			else {
				Logger.error(this.constructor.name, "loadUser(): User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = "Loading User Failed";
				this.setState({ errors });
			}
		}
		catch (error) {
			Logger.error(this.constructor.name, "loadUser() User Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = "Loading User Failed ";
			this.setState({ errors });
		}
	}

	handleScroll = () => {
		// + is unary operator, same as Number(scrollPositionY)
		// const scrollPositionY = +window.scrollY;
		const scrollPositionY = +document.body.scrollTop;
		this.setState({ scrollPositionY });
	}

	renderLogo = (isScrolling) => (
		<img className='landing-header-logo' src={isScrolling ? BluePilotlyLogo : WhitePilotlyLogo} alt='pilotly-logo' />
	);


	goToLogin = () => {
		let sessionStatus = new SessionStatus(SessionStatusEvent.CTA_BASIC_LOGIN, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.buttonLocation = 'Landing';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
		if (this.state.isThirdPartyUser ) {
			this.props.history.push('/login');
		} else {
			this.props.history.push('/home');
		}
	}

	render() {
		const isScrolling = this.disableScroll ? false : !!this.state.scrollPositionY;

		return (
			<header style={{ ...this.props.styles }} className={`landing-header ${isScrolling ? 'sticky-landing-header z-depth-1 blue-bg' : 'z-depth-0'}`}>
				<nav className='landing-header-container-web z-depth-0'>
					<div className='landing-header-btn-container logo-container'>
						<Link className='landing-landing-header-logo-link' push to="/">
							<img className={`landing-header-logo noselect ${isScrolling ? 'sticky-landing-header-logo' : null}`} src={isScrolling ? BluePilotlyLogo : WhitePilotlyLogo} alt='Pilotly' />
						</Link>
					</div>

					{settings.isDev && <LocaleButton />}

					<div className={`landing-header-btn-container ${isScrolling ? 'sticky-landing-header-btn-container' : ''}`}>
						{ this.state.currentUser && !this.state.isThirdPartyUser ?
							<div className={`nav-btns landing-header-remove-btn-highlight ${isScrolling ? 'sticky-nav-btns' : ''}`}>
								<a onClick={this.goToLogin} to='/home' activeClassName="selected">
									<FormattedMessage
										id="landing_header.my_account.link"
										defaultMessage={"My Account"}
									/>
								</a>
							</div>
							: (isTesterFromUrl() ?
								<div className={`nav-btns landing-header-remove-btn-highlight pr-0 ${isScrolling ? 'sticky-nav-btns' : ''}`}>
									<a onClick={this.goToLogin} to='/login' activeClassName="selected">
										<FormattedMessage
											id="landing_header.login.link"
											defaultMessage={"Login"}
										/>
									</a>
								</div>
								:
								<div></div>
							)
						}
					</div>
				</nav>

			</header>
		);
	}
}

const mapStateToProps = state => ({
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	currentUser: state.currentUser.currentUser,
});

export default connect(mapStateToProps, actions)(LandingHeader);



// WEBPACK FOOTER //
// ./src/components/landing/LandingHeader.js